// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/contact-hero-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  width: 100%;
  margin-top: -80px;
}

.contact-hero {
  background: linear-gradient(rgba(39, 31, 18, 0.8), rgba(39, 31, 18, 0.8)),
              url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat;
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: white;
  padding-top: calc(80px + 4rem);
}

.contact-hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.contact-hero h1 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
  color: #D4AF37;
}

.contact-hero p {
  font-size: 1.25rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.contact-content {
  max-width: 1200px;
  margin: -60px auto 4rem;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
}

.quick-links-section {
  position: relative;
}

.quick-links-container {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 100px;
}

.quick-links-container h2 {
  color: #271F12;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.quick-links-grid {
  display: grid;
  gap: 1.5rem;
}

.quick-link-card {
  padding: 1rem;
  border-radius: 8px;
  background: #f8f8f8;
  transition: transform 0.3s ease;
}

.quick-link-card:hover {
  transform: translateY(-2px);
}

.quick-link-card h3 {
  color: #526015;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #D4AF37;
}

.quick-link-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.quick-link-card ul li {
  margin-bottom: 0.5rem;
}

.quick-link-card ul li:last-child {
  margin-bottom: 0;
}

.quick-link-card a {
  color: #271F12;
  text-decoration: none;
  transition: color 0.3s ease;
  display: block;
  padding: 0.3rem 0;
}

.quick-link-card a:hover {
  color: #526015;
}

.contact-info li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #271F12;
}

.contact-info i {
  color: #526015;
  width: 20px;
}

.contact-form-container {
  max-width: 1000px;
  margin: -60px auto 4rem;
  padding: 0 2rem;
}

.contact-form {
  background: white;
  padding: 3rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

label {
  font-family: 'Josefin Sans', sans-serif;
  color: #271F12;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

input,
select,
textarea {
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  font-family: inherit;
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #526015;
}

textarea {
  resize: vertical;
  min-height: 120px;
}

.submit-button {
  background: #526015;
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 2rem;
  width: 100%;
  font-family: 'Josefin Sans', sans-serif;
}

.submit-button:hover {
  background: #455112;
}

@media (max-width: 1024px) {
  .contact-content {
    grid-template-columns: 1fr;
  }

  .quick-links-container {
    position: static;
    margin-bottom: 2rem;
  }

  .quick-links-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .quick-links-grid {
    grid-template-columns: 1fr;
  }

  .contact-content {
    margin-top: -40px;
  }

  .contact-hero h1 {
    font-size: 2.5rem;
  }

  .contact-hero p {
    font-size: 1.1rem;
  }

  .contact-form {
    padding: 2rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 480px) {
  .contact-hero h1 {
    font-size: 2rem;
  }

  .contact-form {
    padding: 1.5rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/ContactForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;4EACuE;EACvE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".contact-page {\n  width: 100%;\n  margin-top: -80px;\n}\n\n.contact-hero {\n  background: linear-gradient(rgba(39, 31, 18, 0.8), rgba(39, 31, 18, 0.8)),\n              url('../assets/contact-hero-bg.jpg') center/cover no-repeat;\n  min-height: 40vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  color: white;\n  padding-top: calc(80px + 4rem);\n}\n\n.contact-hero-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.contact-hero h1 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 600;\n  color: #D4AF37;\n}\n\n.contact-hero p {\n  font-size: 1.25rem;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.contact-content {\n  max-width: 1200px;\n  margin: -60px auto 4rem;\n  padding: 0 2rem;\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 2rem;\n}\n\n.quick-links-section {\n  position: relative;\n}\n\n.quick-links-container {\n  background: white;\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 100px;\n}\n\n.quick-links-container h2 {\n  color: #271F12;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.8rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.quick-links-grid {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.quick-link-card {\n  padding: 1rem;\n  border-radius: 8px;\n  background: #f8f8f8;\n  transition: transform 0.3s ease;\n}\n\n.quick-link-card:hover {\n  transform: translateY(-2px);\n}\n\n.quick-link-card h3 {\n  color: #526015;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.2rem;\n  margin-bottom: 0.8rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #D4AF37;\n}\n\n.quick-link-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.quick-link-card ul li {\n  margin-bottom: 0.5rem;\n}\n\n.quick-link-card ul li:last-child {\n  margin-bottom: 0;\n}\n\n.quick-link-card a {\n  color: #271F12;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  display: block;\n  padding: 0.3rem 0;\n}\n\n.quick-link-card a:hover {\n  color: #526015;\n}\n\n.contact-info li {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #271F12;\n}\n\n.contact-info i {\n  color: #526015;\n  width: 20px;\n}\n\n.contact-form-container {\n  max-width: 1000px;\n  margin: -60px auto 4rem;\n  padding: 0 2rem;\n}\n\n.contact-form {\n  background: white;\n  padding: 3rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\nlabel {\n  font-family: 'Josefin Sans', sans-serif;\n  color: #271F12;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\ninput,\nselect,\ntextarea {\n  padding: 0.75rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 5px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n  font-family: inherit;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: none;\n  border-color: #526015;\n}\n\ntextarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.submit-button {\n  background: #526015;\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-top: 2rem;\n  width: 100%;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.submit-button:hover {\n  background: #455112;\n}\n\n@media (max-width: 1024px) {\n  .contact-content {\n    grid-template-columns: 1fr;\n  }\n\n  .quick-links-container {\n    position: static;\n    margin-bottom: 2rem;\n  }\n\n  .quick-links-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .quick-links-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-content {\n    margin-top: -40px;\n  }\n\n  .contact-hero h1 {\n    font-size: 2.5rem;\n  }\n\n  .contact-hero p {\n    font-size: 1.1rem;\n  }\n\n  .contact-form {\n    padding: 2rem;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .contact-hero h1 {\n    font-size: 2rem;\n  }\n\n  .contact-form {\n    padding: 1.5rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
